<template>
<div class="manager_dashboard">
  <user-menu />
  <div class="wrapper">
    <div class="content-wrapper">
      <div class="container-wrapper center">
      <div>
        <h3 class="d-inline heading">My Task Lists </h3>
      </div>
      <div class="heading-seperator"></div>
      <div class="margin-bottom-10"></div>
      <div style="text-align: center;">
          <flash-message autoHide variant="success"></flash-message>
      </div>

        <div  style="width: 75%; margin: 0 auto;">

          <div class="db-card" >
            <div class="row justify-content-lg-center justify-content-xl-center">
                <div class="col-11">
                    <div class="col-12 p-0" v-if="mappedTaskLists.length > 0">
                        <div class="db-report-card" v-for="(item, lindex) in mappedTaskLists" :key="lindex">
                            <div class="row">
                                <div class="col-9 col-sm-9 col-md-9 col-lg-8 col-xl-9 db_name_block">
                                    <div class="db-mentee-name">{{item.name}}</div>
                                </div>
                                <div class="col-3 col-sm-3 col-md-3 col-lg-4 col-xl-3">
                                    <router-link :to="'/my-tasklists-details/' + item.id" class="btn btn-primary btn-sm dbAddRepsBtn">
                                    View
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-2 db-empty-card" v-else-if="mappedTaskListsCount === 0">
                        <div class="db-empty-card">
                            <h6 class="empty-content-title">No Assigned Task Lists</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        </div>

      </div>  
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';
import { store } from '../../store/store';
import UserMenu from '../shared/user_menu.vue';

export default {
  data() {
   return {
      action: 'view-profile',
      admin_flag: false,
      loading: false,
      mappedTaskLists: [],
      mappedTaskListsCount: '',
      userId: '',
    }
  },
  components: {
    GoBack,
    UserMenu,
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    navigate(pathUrl) {
      router.go({
        path: pathUrl,
        force: true
      });
    },
    isInArray(value, array) {
      return array.indexOf(value) > -1;
    },
  },
  created: function() {
    var roles = this.$store.state.roles;
    if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
      this.masterAdmin = true;
    }
    if(roles.indexOf('ROLE_ENTERPRISE_ADMIN') > -1) {
      this.entepriseAdmin = true;
    }
    if(
      ((roles.indexOf('ROLE_ADMIN') > -1)
      ||
      (this.$store.state.switch_admin_username))
      &&
      ((this.$store.state.switch_flag != 'Instructor')
      &&
      (this.$store.state.switch_flag != 'Mentor'))
      ) {
      this.admin = true;
    }

    if(
      ((roles.indexOf('ROLE_MENTOR') > -1)
      ||
      (roles.indexOf('ROLE_MENTEE') > -1)
      ||
      (roles.indexOf('ROLE_INSTRUCTOR') > -1)
      ||
      (roles.indexOf('ROLE_STUDENT') > -1))
      &&
      ((this.$store.state.switch_flag != 'Manager')
      &&
      (this.$store.state.switch_flag != 'Primary Admin'))
      ) {
      this.showBackButton = true;
    }
    this.loading = true;
    document.body.className = 'profile-page';
    var userAccountId = '';
    if(store.state.user_accountid) {
      userAccountId = store.state.user_accountid;
    }
    axios('/mobile/manager/my-task-lists',
      {
        method: 'GET',
      }
    )
    .then(resp => {
      this.loading = false;
      this.mappedTaskLists = resp.data;
      this.mappedTaskListsCount = this.mappedTaskLists.length;
    })
    .catch(error => {
      this.loading = false;
    })
  },
  mounted() {
    var loggedinUserRoles = store.state.roles;
  },
}
</script>

<style scoped>

.db-card {
  color: #002F42;
  background-color: #FFF;
  width: 100%;
  min-height: 120px;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;  
}
.db-card .db-mentee-name {
  font-weight: 600;
  word-break: break-word;
}
.db-card .db-mentor-name {
  word-break: break-word;
  font-weight: 900;
}
.db-card .db-mentor-name span{
  word-break: break-word;
  font-weight: normal;
}
.grid_row {
  margin-top: 10px;
}
/* .grid_row .cols { padding: 0; } */
.db-card .label_txt {
  font-weight: 900;
  margin-bottom: 5px;
}
.saveBtn, .saveBtn:active, .saveBtn:focus {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 120px;  
}
.container {
    max-width: 990px;
}
.dbViewBtn{
  color: #29A3E4 !important;
  background: none;
  border: 0px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  width: 50px;
  float: right;
  text-decoration: underline !important;
}
.dbViewBtn:focus, .dbViewBtn:active, .dbViewBtn:hover {
  color: #29A3E4 !important;
  background: none;
  border: 0px solid #00acee !important;
  box-shadow: none !important;
} 
.user-icon{ font-size: 60px;  margin-bottom: 10px; }
.mentor_row { margin: 30px; }
.db-card .title{
  font-size: 15px;
  font-weight: 900;
}
.db-card .db-report-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
}
.dbAddRepsBtn {
  color: #29A3E4 !important;
  background: none;
  border: 0px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  width: 50px;
  float: right;
  text-decoration: underline;
}
.dbAddRepsBtn:active, .dbAddRepsBtn:focus {
  color: #29A3E4 !important;
  background: none !important;
  border: 0px solid #00acee !important;
  box-shadow: none !important;
}
.dbGoalBtn {
  text-decoration: underline;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.view-mentee-hr {
    margin-top: 5px;
    margin-bottom: 0px;
    border: 1px solid #e8e8e8;
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
    .statusBtn, .statusBtn:active, .statusBtn:focus {
        width: 100%;
    }
}






.comment-heading {
  padding: 12px 5px 12px 5px;
  font-size: 18px;
  color: #FFF;
  margin-top: 0px;
}
.comment-wrapper {
  padding: 5px;
  background-color: #FFF;
  width: 90%;
  min-height: 100px;
}
.task-title {
  margin: 0px 5px 5px 5px;
  border-bottom: 1px solid #DDD;
}
.task-score {
  font-weight: bold;
}
.comment-text {
  margin-top: 5px;
}
.tip:before {
  position: absolute;
  top: -14px;
  left: 98px;
  display: inline-block;
  border-right: 14px solid transparent;
  border-bottom: 14px solid #fff;
  border-left: 14px solid transparent;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  content: '';
}

.tip:after {
  position: absolute;
  top: -12px;
  left: 99px;
  display: inline-block;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #fff;
  border-left: 12px solid transparent;
  content: '';
}

.tip.left:before {
  border-top: 14px solid transparent;
  border-right: 14px solid #fff;
  border-bottom: 14px solid transparent;
  border-right-color: rgba(169, 169, 169, 1);
  left: -28px;
  top: 20px;
}

.tip.left:after {
  border-top: 12px solid transparent;
  border-right: 12px solid #fff;
  border-bottom: 12px solid transparent;
  left: -24px;
  top: 22px;
}
.tip-left {
  top: 10px;
  left: -25px;
  border-top-color: transparent;
  border-left-color: transparent;
  border-bottom-color: transparent;
}
.tip {
		background: #FFF;
		border: 2px solid #ccc;
		padding: 10px;
		position: relative;
	}
.dialogbox .body {
  position: relative;
  max-width: 300px;
  height: auto;
  margin: 20px 10px;
  padding: 5px;
  border-radius: 3px;
  border: 5px solid #ccc;
}

.body .message {
  min-height: 30px;
  border-radius: 3px;
  font-family: "proxima-nova",sans-serif;
  color: #002F42;
  font-size: 14px;
  line-height: 1.5;
}
    .slide-leave-active,
    .slide-enter-active {
      transition: 0.4s;
    }
    .slide-enter {
      transform: translate(100%, 0);
    }
    .slide-leave-to {
      transform: translate(-100%, 0);
    }
.profile-page .main-wrapper {
   background-color: #FFF;
   padding: 10px;
   min-height: 400px;
   transform: none;
   margin-top:20px;
   width: 50%;
}
@media(max-width:768px) {
  .profile-page .main-wrapper {
     width: 70%;
   }
}
@media (max-width: 560px) {
 .profile-page .main-wrapper {
    border-radius: 5px;
    width: 100%;
  }
}
@media (max-width: 575.98px) {
  .col-xs-1 {
   width: 8.33333333%;
  }
  .col-xs-11 {
    width: 91.66666667%;
  }
  .col-xs-4 {
    width: 33.333333%;
  }
  .col-xs-8 {
    width: 66.666667%;
  }
  .col-xs-9 {
    width: 75%;
  }
  .col-xs-3 {
    width: 25%;
  }
}
.content-main-wrapper h3 {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  color: #555;
}
.marginbot10 {
  margin-bottom: 10px;
}
.profile-heading {
  margin-top: 10px;
}
label {
  font-size: 12px;
}
.profile-sec-sep {
  border-top: 1px solid #DDD;
  margin: 20px 0px 20px 0px;
}
#profile-link-wrapper .profile-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}
#edit-profile-wrapper label {
  padding-left: 0px;
}
.edit-profile-wrapper .submit{
  padding-right: 15px;
  margin-top: 10px;
}
.custom-chkbox {
  width: 10%;
  float: left;
}
label.group-chkbox {
  font-weight: normal;
}
.roles { text-transform: capitalize; }
.profile-container label{
  font-weight:bold;
}
.profile-container .chkboxwrapper label{
  font-weight:normal;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 23px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.notification-wrapper .label-bold {
  padding-top: 3px;
  font-size: 12px;
  font-weight: bold !important;
}
.create_tasks_status label {
  font-weight: normal;
  font-size: 14px;
}
.edit-profile-wrapper {
  padding-top: 10px;
}
.question_text, .question_text a, .question_text a:hover {
  font-size: 11px;
}
.start-button {
    color: #00acee;
    background-color: #FFF;
    border: 1px solid #00acee;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 5px;
    line-height: 8px;
    width: 65px;
}
.begin-course-button {
    color: #fff;
    background-color: #00acee;
    border: 1px solid #00acee;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 15px 10px 15px;
    line-height: 8px;
    width: auto; 
}

</style>



// WEBPACK FOOTER //
// src/components/manager/my_tasklists.vue